import React, { createContext, useContext, useMemo, useState } from "react";

const GlobalBgContext = createContext(null);

export function GlobalBgProvider({ children }) {
  const [bgKey, setBgKey] = useState(null);

  // NEW: lock to disable transitions during invisible jumps
  const [bgLocked, setBgLocked] = useState(false);

  const value = useMemo(
    () => ({ bgKey, setBgKey, bgLocked, setBgLocked }),
    [bgKey, bgLocked]
  );

  return (
    <GlobalBgContext.Provider value={value}>{children}</GlobalBgContext.Provider>
  );
}

export function useGlobalBg() {
  const ctx = useContext(GlobalBgContext);
  if (!ctx) throw new Error("useGlobalBg must be used within GlobalBgProvider");
  return ctx;
}
